<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

import { Sport } from '@collector/sportsapi-client-legacy'

interface Props {
  sportName: Sport['name']
  patternId: number
  firstColor?: `#${string}`
  secondColor?: `#${string}`
  thirdColor?: `#${string}`
}

withDefaults(defineProps<Props>(), {
  firstColor: '#a2a2a2',
  secondColor: '#e6e6e6',
  thirdColor: '#e6e6e6',
})
</script>

<template>
  <component
    :is="
      defineAsyncComponent(
        () => import(`./patterns/${sportName}/Pattern${patternId}.vue`),
      )
    "
    :firstColor
    :secondColor
    :thirdColor
  />
</template>
